import Vue from 'vue'

export default ({ store }) => {
    if(Vue.localStorage.get('Currency')){
        store.commit('setCurrency', Vue.localStorage.get('Currency'))
    }
}